module.exports = __webpack_public_path__ + "static/media/empty_state.53268dda.svg";